import React from 'react';
import styles from './HeaderLogo.module.scss';

export default function HeaderLogo() {
  return (
    <div className={styles.container}>
      <a
        href="https://www.xmatters.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className={styles.image}
          src="/assets/images/xmatters-everbridge-logo.svg"
          alt="Everbridge xMatters Logo"
        />
      </a>
    </div>
  );
}

HeaderLogo.displayName = 'HeaderLogo';
